const STORAGE_KEY = 'cp_dashboard_date_range_v2';

export function getDefaultRange(): { from: string; to: string } {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return { from: today, to: today };
}

export function getStoredRange(): { from: string; to: string } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as { from?: string; to?: string };
      if (parsed.from && parsed.to) return { from: parsed.from, to: parsed.to };
    }
  } catch {
    // ignore
  }
  return getDefaultRange();
}

export function saveRange(from: string, to: string) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ from, to }));
  } catch {
    // ignore
  }
}
